export default {
  de: {
    add: 'Seiten',
    remove: 'Seiten',
    pages: 'Seiten:',
  },
};
